import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import * as Yup from "yup";
import { Formik, FieldArray, Field } from "formik";
import config from "../../../../config";
import yupconfig from "../../../../yupconfig";
import moment from 'moment';
import { BookingResourceModal, BookingSelectedServicesData, BookingStaffAvailableTimeApi, NextStep } from 'store/slices/bookingSlice';
import Select from "react-select";
import customToast from 'component/Toastr';

const BookingResourceModals = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [loading,setLoading] = useState(false);
    const isBookingResourceModal = useSelector((state) => state.booking.isBookingResourceModal);
    const isBookingResourceItem = useSelector((state) => state.booking.isBookingResourceItem);
    const isBookingStepFourData = useSelector((state) => state.booking.isBookingStepFourData);
    const availebleTimeObj = isBookingStepFourData && isBookingStepFourData.availebleTimeObj;
    const singleSelectedServiceData = isBookingStepFourData && isBookingStepFourData.singleSelectedServiceData;
    const isBookingStep = isBookingStepFourData && isBookingStepFourData.isBookingStep;
    // console.log("isBookingStepFourData", isBookingStepFourData)

    const initialValues = {
        resource_item_id: "",
        NextStep: false,
    };

    const validationSchema = Yup.object().shape({
        resource_item_id: Yup.lazy((val) => (Array.isArray(val) ? Yup.array().of(Yup.string()).nullable().min(1).required() : Yup.string().nullable().label(t("Resource")).required())),
    });
    yupconfig();

    const handleEmailVerifications = async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
        try {
            if(values.NextStep){
                dispatch(NextStep(isBookingStep));
                dispatch(BookingResourceModal(""))
            }else{
                customToast.error("This staff with resource is not availble this time");
                setErrors({ resource_item_id: "This staff with resource is not available this time" });
                setStatus({ success: false });
                setLoading(false);
            }
        } catch (err) {
            setErrors(err.message);
            setStatus({ success: false });
            setLoading(false);
        }
    };

    const ResourceDropDown = isBookingResourceItem && isBookingResourceItem.length > 0 ? isBookingResourceItem : [];


    return (
        <div>
            <div className={isBookingResourceModal === "open" ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: isBookingResourceModal === "open" ? "block" : "none" }}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleEmailVerifications}>
                    {(formik) => {
                        // console.log(formik.values)
                        return (
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <form noValidate onSubmit={formik.handleSubmit}>
                                        <div className="modal-body pb-0">
                                            <div className="p-3">
                                                <h5 className="mb-3 fw-semibold text-dark">{t("Choose resource.")}</h5>

                                                <div className="mb-3">
                                                    <Select
                                                        options={ResourceDropDown}
                                                        isClearable={true}
                                                        // styles={customStyles}
                                                        placeholder={"Choose Resource"}
                                                        name="resource_item_id"  // Use the name property, not formik.values.resource_item_id
                                                        onChange={(selectedOption) => {
                                                            const resource_item_id = selectedOption && selectedOption.value ? selectedOption.value : ""
                                                            const resource_item_name = selectedOption && selectedOption.label ? selectedOption.label : ""
                                                            formik.setFieldValue("resource_item_id", resource_item_id);
                                                            dispatch(BookingStaffAvailableTimeApi({...availebleTimeObj, resource_item_id: resource_item_id})).then((action) => {
                                                                if (action.meta.requestStatus === "fulfilled") {
                                                                    const response = action.payload;
                                                                    if (response && response.time && response.time.length === 0) {
                                                                        customToast.error("This staff with resource is not availble this time")
                                                                        formik.setFieldValue("NextStep", false);
                                                                    } else {
                                                                        // console.log('obj',availebleTimeObj);
                                                                        formik.setFieldValue("NextStep", true);
                                                                        const obj =  { ...singleSelectedServiceData, 
                                                                            staff_id: availebleTimeObj.staff_id, 
                                                                            datetime: availebleTimeObj.parentAppointmentEndTime, 
                                                                            duration:availebleTimeObj.duration, 
                                                                            padding_time:availebleTimeObj.duration, 
                                                                            durationWithPadding:availebleTimeObj.duration, 
                                                                            parentAppointmentEndTime:availebleTimeObj.parentAppointmentEndTime, 
                                                                            resource_item_id:resource_item_id,
                                                                            resource_name:resource_item_name,
                                                                        }
                                                                        // console.log('obj',obj);
                                                                        dispatch(BookingSelectedServicesData(obj));
                                                                        
                                                                    }
                                                                    // 
                                                                } else if (action.meta.requestStatus === "rejected") {
                                                                    const status = action.payload && action.payload.status;
                                                                    const errors = action.payload && action.payload.message && action.payload.message.errors;
                                                                    const response = action.payload && action.payload.message && action.payload.message;
                                                                    if (status === 422) {
                                                                        const NotifyContent = () => {
                                                                            return (
                                                                                <>
                                                                                    <p className="mb-2 text-light text-justify">{response && response.message}</p>
                                                                                    <ul className="list-unstyled">
                                                                                        {errors &&
                                                                                            Object.keys(errors).map((a, n) => {
                                                                                                if (errors[a].length > 0) {
                                                                                                    return (
                                                                                                        <>
                                                                                                            {errors[a].map((as, ns) => {
                                                                                                                return (
                                                                                                                    <li key={n + "-" + ns} className="text-light form-text text-start">
                                                                                                                        {as}
                                                                                                                    </li>
                                                                                                                );
                                                                                                            })}
                                                                                                        </>
                                                                                                    );
                                                                                                }
                                                                                            })}
                                                                                    </ul>
                                                                                </>
                                                                            );
                                                                        };
                                                                        customToast.error(<NotifyContent />);
                                                                    } else if (status === 410) {
                                                                        const NotifyContent = () => {
                                                                            return (
                                                                                <>
                                                                                    <p className="mb-2 text-light text-justify">{response && response.message}</p>
                                                                                    <ul className="list-unstyled">
                                                                                        {errors &&
                                                                                            Object.keys(errors).map((a, n) => {
                                                                                                if (errors[a].length > 0) {
                                                                                                    return (
                                                                                                        <>
                                                                                                            {errors[a].map((as, ns) => {
                                                                                                                return (
                                                                                                                    <li key={n + "-" + ns} className="text-light form-text text-start">
                                                                                                                        {as}
                                                                                                                    </li>
                                                                                                                );
                                                                                                            })}
                                                                                                        </>
                                                                                                    );
                                                                                                }
                                                                                            })}
                                                                                    </ul>
                                                                                </>
                                                                            );
                                                                        };
                                                                        customToast.error(<NotifyContent />);
                                                                    }
                                                                }
                                                            });
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                border: "1px",
                                                                primary25: "#F4EEEB",
                                                                primary: "#8C1C4D",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mt-3 bg-cream p-4 justify-content-center">
                                                <div className="col-6">
                                                    <button className="preview btn me-1 cursor-pointer btn-preview w-100" onClick={() => {
                                                        dispatch(BookingResourceModal(""));
                                                    }}>
                                                        {t("Cancel")}
                                                    </button>
                                                </div>
                                                <div className="col-6">
                                                    <button className="btn btn-primary w-100" type='submit'>
                                                        {t("Confirm")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )
                    }}
                </Formik>
            </div>
            {isBookingResourceModal === "open" && <div className="modal-backdrop show"></div>}
        </div>
    )
}

export default BookingResourceModals;